module.exports = __webpack_public_path__ + "static/flags/FI-9586d67557313fa5a4f007807eb30a28.gif";